import { render, staticRenderFns } from "./storesList.vue?vue&type=template&id=4b3c4179&"
import script from "./storesList.vue?vue&type=script&lang=js&"
export * from "./storesList.vue?vue&type=script&lang=js&"
import style0 from "./storesList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports